import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    gridRow: {
        display: 'flex',
        justifyContent: 'center',
    },
    card: {
        margin: theme.spacing(4),
        width: '64rem',
        maxWidth: '100%',
    },
    cardContent: {
        paddingTop: 0,
    },
    intro: {
        marginBottom: theme.spacing(2),
    },
    listItem: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    listItemIcon: {
        minWidth: theme.spacing(3),
    },
    bulletIcon: {
        fontSize: '0.5rem',
        color: theme.palette.primary.main,
    },
    bestSellerChip: {
        marginLeft: theme.spacing(1.5),
        height: 20,
        fontSize: '0.7rem',
    },
    sectionTitle: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        fontWeight: 'bold',
    },
    paragraph: {
        marginBottom: theme.spacing(2),
    },
    contactBlock: {
        marginTop: theme.spacing(3),
    },
    cardActions: {
        padding: theme.spacing(2, 2, 3),
        justifyContent: 'center',
    },
}));
